import { Component } from 'react';
import { sendGAEvent } from 'trackers/ga';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error: error };
    }

    async componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({ errorInfo: errorInfo });
        sendGAEvent('U81bd19754c6a92eaf3b0c25b26c0d8ed', 'ErrorBoundary', { _label: error.toString() }); // 發送錯誤訊息到GA
    }
    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Something went wrong.</h1>
                </div>
            );
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
